import React from 'react'

import { FaArrowRight } from "react-icons/fa";
import '../styles/sliderstyle.scss'


export default ({to, onClick}) => (
  <button type="button" onClick={onClick} className={`button button--text button--icon slidericon`} aria-label={to}>
    <FaArrowRight className="icon" icon={to} />
  </button>
)